// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fill-button-base-hbkWO {
  background-color: var(--accent-color);
}

.fill-button-base-hbkWO .fill-button-text-BwqeF {
  color: white;
}

@media (pointer: fine) {

  .fill-button-base-hbkWO:hover {
    background-color: #db1a1a;
  }
}

.fill-button-base-hbkWO:active {
  background-color: #c40b0b;
}

.fill-button-disabled-DY0Ck {
  background-color: var(--border-color);
}

.fill-button-disabled-DY0Ck .fill-button-text-BwqeF {
  color: gray;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/fill-button/fill-button.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb","sourcesContent":[".base {\n  background-color: var(--accent-color);\n}\n\n.base .text {\n  color: white;\n}\n\n@media (pointer: fine) {\n\n  .base:hover {\n    background-color: #db1a1a;\n  }\n}\n\n.base:active {\n  background-color: #c40b0b;\n}\n\n.disabled {\n  background-color: var(--border-color);\n}\n\n.disabled .text {\n  color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `fill-button-base-hbkWO`,
	"text": `fill-button-text-BwqeF`,
	"disabled": `fill-button-disabled-DY0Ck`
};
export default ___CSS_LOADER_EXPORT___;
